import Vue from 'vue';
import Vuex from 'vuex';
import chat from '../chat/store/chat';
import attachment from '../attachment/store/attachment';
import recept from '../recept/store/recept';
import report from '../report/store/report';
import conference from "../opentok/store/conference";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
		chat,
        attachment,
        recept,
        report,
        conference
    },
	state: {
		user: window.laravel.user,
		consultation: window.laravel.consultation,
        patient: window.laravel.patient,
        windowWidth: window.innerWidth
	},
    mutations: {
        setConsultation(state, consultation){
            state.consultation = consultation;
        }
    }
});
